import { mapMutations } from 'vuex'

export default {
  name: 'AppFeatureToggle',
  methods: {
    ...mapMutations('featureToggle', {
      storeFeaturesRules: 'STORE_FEATURE_RULES'
    })
  },
  render () {
    return null
  },
  created () {
    this.$firebase.collection('features').onSnapshot(snapshot => {
      if (snapshot) {
        let features = {}

        snapshot.forEach(doc => {
          features[doc.id] = doc.data()
        })

        this.storeFeaturesRules(features)
      }
    })
  }
}
